import * as $          from 'jquery';
import { onLoad }     from 'Core/Events';
import {$body} from "Core/Body";
import {Decimal} from "decimal.js";

export const FacebookPixelDynamicEvents = (() => {

    const Selector = {
        ADD_TO_CART:           '.js_fb_add_to_cart',
        QUANTITY:              '.js_product_page_quantity'
    };

    function facebookEventAddToCart(e)
    {
        let btn = $(e.target);
        let quantity = $(Selector.QUANTITY).val() as number || 1;
        let price = new Decimal(btn.data('fb-price') * quantity ).toFixed(2);

        let fbComponentData = {
            content_ids : [btn.data('fb-ids')],
            content_name : btn.data('product-name'),
            content_type: 'product',
            contents : [{id : btn.data('fb-ids'),
                quantity : quantity,
                price : price
            }],
            currency: btn.data('fb-currency'),
            value : price
        }

        // @ts-ignore
        if(window.fbq !== undefined){
            // @ts-ignore
            fbq('track', 'AddToCart', fbComponentData);
        }
    }

    $body.on("click", Selector.ADD_TO_CART, facebookEventAddToCart);

    return true;
})();
import * as $          from 'jquery';
import { onLoad }     from 'Core/Events';
import {$body} from "Core/Body";
import {Decimal} from "decimal.js";

export const FacebookPixelDynamicEvents = (() => {

    const Selector = {
        ADD_TO_CART:           '.js_fb_add_to_cart',
        QUANTITY:              '.js_product_page_quantity'
    };

    function facebookEventAddToCart(e)
    {
        let btn = $(e.target);
        let quantity = $(Selector.QUANTITY).val() as number || 1;
        let price = new Decimal(btn.data('fb-price') * quantity ).toFixed(2);

        let fbComponentData = {
            content_ids : [btn.data('fb-ids')],
            content_name : btn.data('product-name'),
            content_type: 'product',
            contents : [{id : btn.data('fb-ids'),
                quantity : quantity,
                price : price
            }],
            currency: btn.data('fb-currency'),
            value : price
        }

        // @ts-ignore
        if(window.fbq !== undefined){
            // @ts-ignore
            fbq('track', 'AddToCart', fbComponentData);
        }
    }

    $body.on("click", Selector.ADD_TO_CART, facebookEventAddToCart);

    return true;
})();
